<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Header con Filtros y Acciones -->
          <ProductListTableHeader
            :title='$t("key_stockProductList_table_title")'
            :description='$t("key_stockProductList_table_description")'
            :enable-reload="true"
            :enable-search="true"
            :selected-ids="selectedIds"
            :list-filters="filters"
            @search-change="searchChange"
            @reload-page="reloadPage"
            @export-data="exportData"
            @stock-product-status-filter-change="stockProductStatusFilterChange"
            @stock-product-warehouse-filter-change="stockProductWarehouseFilterChange">  <!-- TODO: Pendiente de calibrar los componentes por las preferencias del usuario --> 
          </ProductListTableHeader>
          
          <!-- Tabla con los Datos -->
          <GenericTableV2
            ref="genericTable"
            :items="stockProductsData?.items"
            :pagination="pagination"
            :headers="headers"
            :selected-ids="selectedIds"
            :is-loading="isLoading"
            @changed-header="onChangeHeader"
            @changed-page="paginationPageChange"
            @changed-row="paginationRowChange"
            @changed-selection="changedSelection">
            <template #row="{item}">
              <td style="width: 15%" class="text-xs cursor-pointer font-weight-bold mb-0 picko-link">
                <div class="d-flex">
                  <div class="my-auto form-check">
                    <input :id="item._id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item._id)" @change="changedSelection(item._id)" >
                  </div>
                  <div class="d-lg-flex">
                    <div class="my-auto ms-3 picko">
                      <img class="d-inline" :class="!item.product_image? 'noimageColor': 'image'"  :src="!item.product_image? noimage: item.product_image" :alt="$t('key_products_image')" />
                    </div>
                    <div class="my-auto mt-4 ms-auto mt-lg-0">
                      <h6 class="my-auto text-sm ms-3 font-weight-bold">
                        <a class="text-xs text-primary" href="#" @click.prevent="openProduct(item.product_id)">
                          {{ item.product_name }}
                        </a>
                      </h6>
                      <span class="text-xs font-weight-bold ms-3">
                        {{ item.product_variant.variant_property_1 }} - {{ item.product_variant.variant_property_2 }}
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.product_variant.variant_ean}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.warehouse_name}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.product_season}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.product_family}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.product_subfamily}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.product_variant.variant_sku}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.lot_number}}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{item.lot_date}}</span>
              </td>
              <td class="font-weight-bold text-success">
                <span class="my-2 text-xs">{{$numberFormat.toDecimalFormat(item.units_available)}}</span>
              </td>
              <td class="font-weight-bold text-warning">
                <span class="my-2 text-xs">{{$numberFormat.toDecimalFormat(item.units_booked)}}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="item.product_status == 0" class="badge badge-calculating badge-sm">{{ $t('key_stock_calculating') }}</span>
                <span v-else-if="item.product_status == 1" class="badge badge-stock badge-sm">{{ $t('key_stock_stock') }}</span>
                <span v-else-if="item.product_status == 2" class="badge badge-notavailable badge-sm">{{ $t('key_stock_not_available') }}</span>
                <span v-else class="badge badge-outofstock badge-sm">{{ $t('key_stock_out_of_stock') }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs">{{$dateUtils.toDDMMYYYYHH(item.updated_at)}}</span>
              </td>
            </template>
          </GenericTableV2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  // IMPORTS
  import { mapState, mapActions } from "vuex";
  import GenericTableV2 from "./../../../../generic_components/GenericTableV2.vue";
  import ProductListTableHeader from "./../components/ProductListTableHeader.vue";
  import noimage from  "@/assets/img/sevica-images/noimage.png";
  import Cookies from 'js-cookie';

  export default {
    name: "StockProductList",
    components: {
      GenericTableV2,
      ProductListTableHeader,
    },
    data() {
      return{
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: "",
          status: "",
          sort: {
            sort: "",
            order: ""
          },
          warehouse: ""
        },
        isLoading: false,
        isExporting: false,
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200]
        },
        noimage,
        selectedIds: []
      }
    },
    computed: {
      ...mapState("stock", {
        stockProductsData: state => state.list.data,
        stockProductsResponse: state => state.list.response,
        stockProductsStatus: state => state.list.status,
        exportStockProductsData: state => state.export.data,
        exportStockProductsStatus: state => state.export.status
      }),
      listFilters() {
        return this.$store.state.stock.listFilters;
      },
      headers() {
        return [
          { title: this.$t("key_theader_products"), sort: { sorteable: true, order: "" }, column: "product_name" },
          { title: this.$t("key_theader_ean"), sort: { sorteable: true, order: "" }, column: "product_variant.variant_ean" },
          { title: this.$t("key_theader_warehouse"), sort: { sorteable: true, order: "" }, column: "warehouse_name" },
          { title: this.$t("key_theader_season"), sort: { sorteable: true, order: "" }, column: "product_season" },
          { title: this.$t("key_theader_family"), sort: { sorteable: true, order: "" }, column: "product_family" },
          { title: this.$t("key_theader_subfamily"), sort: { sorteable: true, order: "" }, column: "product_subfamily" },
          { title: this.$t("key_theader_sku"), sort: { sorteable: true, order: "" }, column: "product_variant.variant_sku" },
          { title: this.$t("key_theader_batch"), sort: { sorteable: true, order: "" }, column: "lot_number" },
          { title: this.$t("key_theader_batch_date"), sort: { sorteable: true, order: "" }, column: "lot_date" },
          { title: this.$t("key_theader_WarehouseList_available"), sort: { sorteable: true, order: "" }, column: "units_available" },
          { title: this.$t("key_theader_WarehouseList_booked"), sort: { sorteable: true, order: "" }, column: "units_booked" },
          { title: this.$t("key_theader_status"), sort: { sorteable: true, order: "" }, column: "product_status" },
          { title: this.$t("key_theader_WarehouseList_updated_at"), sort: { sorteable: false, order: "" }, column: "updated_at" }
        ]
      }
    },
    watch: {
      stockProductsResponse() {
        if(this.stockProductsData) {
          this.pagination.total = this.stockProductsData.total;
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.setUpFilters();
      if (this.$router.options.history.state.warehouse !== "" && this.$router.options.history.state.warehouse !== undefined)
        this.filters.warehouse = this.$router.options.history.state.warehouse;
      if (Object.keys(this.$route.query).length > 0) {
        this.filters.status = this.$route.query.status;
        this.filters.warehouse = this.$route.query.warehouse;
      }
      this.getStockProductsList();
    },
    methods: {
      ...mapActions("stock",  [
                                "getStockProducts",
                                "exportStockProducts"
                              ]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters["filters"])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == "descending" ? "desc" : "asc"
          }

          return newHeader
        })
      },
      async getStockProductsList() {
        if (this.stockProductsStatus === "loading" || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          await this.getStockProducts({filters: this.filters, pagination: this.pagination});
          
          if (this.stockProductsStatus === "success" && this.stockProductsResponse.status === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t("key_header_successful_retrieving_data"),
              message: this.$t("key_message_successful_retrieving_data"),
              icon: { component: "fa-solid fa-check", color: "white" },
              color: "success",
              show: true,
              duration: 5000
            });
          } else if(this.stockProductsStatus !== "success") {
            this.$notify({
              title: this.$t("key_header_error_retrieving_data"),
              message: this.$t("key_message_error_retrieving_data"),
              icon: { component: "fa-solid fa-xmark", color: "white" },
              color: "danger",
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t("key_header_error_unexpected"),
            message: this.$t("key_message_error_unexpected"),
            icon: { component: "fa-solid fa-xmark", color: "white" },
            color: "danger",
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      changedSelection(id) {
        if (this.selectedIds.includes(id)) {
          this.selectedIds = this.selectedIds.filter(itemId => itemId !== id);
        } else {
          this.selectedIds.push(id);
        }
      },
      clearSelection() {
        this.selectedIds = [];
      },
      async searchChange(value) {
        this.pagination.currentPage = 1;
        this.filters.search = value;
        await this.getStockProductsList();
      },
      async reloadPage() {
        await this.getStockProductsList();
      },
      async exportData() {
        let savedLanguage = Cookies.get('Picko.language') || 'en';

        if (this.exportStockProductsStatus === "loading" || this.isExporting) {
          return;
        }

        this.isExporting = true;
        try {
          await this.exportStockProducts({filters: this.filters, language: savedLanguage});
          
          if (this.exportStockProductsStatus === "success") {
            const blob = this.exportStockProductsData;
            
            if (blob) {
              const link = document.createElement("a");
              const currentDate = new Date();
              const formattedDate = currentDate.toISOString().split("T")[0];

              link.setAttribute("download", `Stock-${formattedDate}.xlsx`);
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              setTimeout(() => URL.revokeObjectURL(link.href), 100);
            }
            this.$notify({
              title: this.$t("key_header_successful_exporting_data"),
              message: this.$t("key_message_successful_exporting_data"),
              icon: { component: "fa-solid fa-download", color: "white" },
              color: "success",
              show: true,
              duration: 5000
            });
          } else if(this.stockProductsStatus !== "success") {
            this.$notify({
              title: this.$t("key_header_error_exporting_data"),
              message: this.$t("key_message_error_exporting_data"),
              icon: { component: "fa-solid fa-xmark", color: "white" },
              color: "danger",
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t("key_header_unexpected_error_exporting_data"),
            message: this.$t("key_message_unexpected_error_exporting_data"),
            icon: { component: "fa-solid fa-xmark", color: "white" },
            color: "danger",
            show: true,
            duration: 5000
          });
        } finally {
          this.isExporting = false;
        }
      },
      async onChangeHeader(val) {
        this.filters.sort = {
          sort: val.column,
          order: val.order=="asc"?"ascending":"descending"
        }
        await this.getStockProductsList(); 
      },
      async paginationPageChange(page) {
        this.pagination.currentPage = page;
        await this.getStockProductsList(); 
      },
      async paginationRowChange(rows) {
        this.pagination.rows = rows;
        await this.getStockProductsList();
      },
      async stockProductStatusFilterChange(val) {
        this.pagination.currentPage = 1;
        this.filters.status = val;
        await this.getStockProductsList();
      },
      async stockProductWarehouseFilterChange(val) {
        this.pagination.currentPage = 1;
        this.filters.warehouse = val;
        await this.getStockProductsList();
      },
      openProduct(id) {
        if (id) {
          this.$router.push({ path: "/MasterData/Products/EditProduct/" + id});
        }
      }
    }
  };

</script>

<style scoped>

  .back-button {
    color: #4A7062
  }

  .image{
    height: 2.2rem !important;
    border-radius: 9%;
  }

</style>